import clsx from "clsx";
import { graphql } from "gatsby";
import React, { FC } from "react";

import { CtaHeaderMenuItem } from "./cta-header-menu-item";
import { NestedHeaderMenuItem } from "./nested-header-menu-item";

export interface HeaderMenuItemProps {
  size: "large" | "small";
  item:
    | (Queries.HeaderMenuItemDataFragment & { __typename: "ContentfulHeaderMenuItem" })
    | (Queries.CtaDataFragment & { __typename: "ContentfulCta"; id: string });
}

export const HeaderMenuItem: FC<HeaderMenuItemProps> = ({ item, size }) => {
  const textSizeClass = clsx(
    size === "large" && "text-3xl lg:text-xl font-bold",
    size === "small" && "text-lg lg:text-sm"
  );

  return item.__typename === "ContentfulCta" ? (
    <CtaHeaderMenuItem {...item} className={textSizeClass} />
  ) : (
    <NestedHeaderMenuItem {...item} className={textSizeClass} />
  );
};

export const query = graphql`
  fragment HeaderMenuItemData on ContentfulHeaderMenuItem {
    id
    title
    tabs {
      ...HeaderMenuItemTabData
    }
  }
`;
